<script>

export default {
    name: "TimezonePicker",
    props: {
        visit: {
          type: Object,
          required: true
        },
        id: {
            type: String,
            default() {
                return "timezone"
            }
        },
        name: {
            type: String,
            default() {
                return "timezone"
            }
        },
        value: {
            type: String,
            required: true
        },
        // TODO: To make it stand alone without needing to pass the array of 
        timezones: {
            type: Array
        },

    },
    data() {
        return {
            selected: this.value
        }
    },
    mounted() {
        $(this.$refs.select).select2();
        $(this.$refs.select).on('change', (event) => {
        let selectedValue =  $(this.$refs.select).val();
        this.selected = selectedValue;
        this.visit.timezone = selectedValue;
      });
    }
}
</script>

<template>
    <div>
        <select ref="select" v-model="selected" :id="id" :name="name" class="selectpicker form-control timezone input-new-design">
            <option v-for="timezone of timezones" :value="timezone.value" :selected="timezone.value === selected">
                {{ timezone.timezone }}
            </option>
        </select>
    </div>
</template>

<style scoped>

</style>